// Vite-only env access, quarantined in its own module.
//
// `import.meta` is a *syntax* error for CRA's Jest/Babel transform ("Cannot use 'import.meta'
// outside a module"), so it fails at parse time -- no runtime guard can dodge it. Anything that
// transitively imports a file containing it dies before its first assertion, and the offenders sat
// in high-traffic places: config/api.ts under authService -> LoginButton -> ReqUserContext -> ... ->
// RichTextInput (most of the component tree), plus App.tsx itself and the DevInfoWidget it renders.
//
// Same idea as src/cpts/Form/CoreCpts/lib/urls.ts, which src/setupTests.ts mocks globally for the
// same reason -- but wired differently: this module is swapped at *resolution* time by
// `jest.moduleNameMapper` in cra/package.json (pattern `(^|/)viteEnv$`, so it matches from any
// depth), which means no dependency on setup-file ordering. Importers stay plain, parseable
// TypeScript and keep ownership of their own fallback values.
//
// Adding a var here? Mirror it in __mocks__/viteEnv.ts with the value Vite yields when it is unset.
export const VITE_OTP_AUTH_BASE_URL: string | undefined = import.meta.env.VITE_OTP_AUTH_BASE_URL;

// Read by App.tsx's TenantApp to pick the tenant app directory before falling back to
// HSPPConfig.frontendAppDirName from the backend.
export const VITE_FRONTEND_TENANT_DIR: string | undefined = import.meta.env.VITE_FRONTEND_TENANT_DIR;

// Build stamps shown by cpts/lib/DevInfoWidget, which App.tsx renders.
export const VITE_COMMIT_HASH: string | undefined = import.meta.env.VITE_COMMIT_HASH;
export const VITE_BUILD_TIMESTAMP: string | undefined = import.meta.env.VITE_BUILD_TIMESTAMP;
